// @flow
import * as React from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import CopyToClipboard from 'react-copy-to-clipboard';
import { CSSTransitionGroup } from 'react-transition-group';
import {
  validateRequired,
  validateFileName,
  validateABN,
  validateACN
} from '../../helpers';
import Input from '../../components/Input';

type Props = {
  currentCustomer: Object,
  handleSubmit: Function,
  currentLocation: Object,
  successMsg: string,
  errorMsg: string,
  isNew: boolean,
  isSaving: boolean
};

type State = {
  copied: boolean
};

class LocationDetailsForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      copied: false
    };
  }

  copyToClipboard = () => {
    this.setState({ copied: true });
    setTimeout(() => this.setState({ copied: false }), 3000);
  };

  render() {
    const { id } = this.props.currentLocation;
    return (
      <div>
        <Row />
        <Form onSubmit={this.props.handleSubmit}>
          {!this.props.isNew && (
            <Row>
              <Col sm={12}>
                <header className="form-input no-input">
                  <strong>Sub-Account ID: </strong>&nbsp;<small>{id}</small>
                  <CopyToClipboard
                    text={id}
                    className="copy-clipboard"
                    onCopy={this.copyToClipboard}
                  >
                    <span>
                      <i className="glyphicon glyphicon-copy" />
                      Copy ID
                    </span>
                  </CopyToClipboard>
                  {this.state.copied ? (
                    <span className="copy-success">Copied.</span>
                  ) : null}
                </header>
              </Col>
            </Row>
          )}
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="text"
                label="Sub-Account name"
                placeholder="Sub-Account name"
                name="name"
                validate={[validateRequired, validateFileName]}
              />
            </Col>
          </Row>

          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="toggle"
                name="isArchived"
                label="Active"
                reverse
              />
            </Col>
          </Row>

          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="phone"
                label="Phone"
                placeholder="Phone"
                name="phone"
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="text"
                label="External reference"
                placeholder="External reference"
                name="referenceNo"
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="autocomplete"
                label="Address"
                placeholder="Address"
                name="address"
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="text"
                label="ABN"
                placeholder="ABN"
                name="abn"
                validate={validateABN}
                parse={val => val && val.replace(/\s+/g, '')}
                format={val => val && val.replace(/\s+/g, '')}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="text"
                label="ACN"
                placeholder="ACN"
                name="acn"
                validate={validateACN}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="form-input">
              <Button
                bsStyle="primary"
                type="submit"
                disabled={this.props.isSaving}
              >
                {this.props.isSaving ? 'Saving...' : 'Save'}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <CSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
              >
                {this.props.successMsg && (
                  <p className="text-success">{this.props.successMsg}</p>
                )}
              </CSSTransitionGroup>
            </Col>
          </Row>
        </Form>
        {this.props.errorMsg && (
          <div className="alert alert-danger">{this.props.errorMsg}</div>
        )}
      </div>
    );
  }
}

// Decorate the form component
LocationDetailsForm = reduxForm({
  form: 'locationDetailsForm' // a unique name for this form
})(LocationDetailsForm);

export default LocationDetailsForm;



// WEBPACK FOOTER //
// ./src/containers/location/LocationDetailsForm.js